import { IThemeProps } from "component/theme";
import styled from "styled-components";

export const StyledAddNewFeature = styled.div(({ theme }: IThemeProps) => `
  padding: 20px;
  .title {
    margin: 10px 0 40px;
    color: ${theme.uptimeColors.textColors.primary}
  }
  
  .MuiCheckbox-root {
    input[type='checkbox'] + svg {
      color: ${theme.uptimeColors.generalColors.icon.enabled};
    }
  }

  input[type='text']:disabled {
    cursor: not-allowed;
  }

  .group-button {
    display: flex;
    margin: 30px 0 0;
    .hlx-btn {
      margin-left: 30px;
      &:first-child {
        margin-left: 0;
      }
      .Mui-disabled {
        cursor: not-allowed;
        pointer-events: auto;
      }
    }
  }

`);
